define([],
	function() {
		var ElementsPathUtils = function(){
			this.getPathRegex = function(pathString, groups){
                if (!pathString) return;
				var mask = pathString,
					wildcard = (groups === true)?"(.*)":".*";
				mask = mask.replace(/[.+?^${}()|[\]\\]/g, "\\$&");
				mask = mask.replace(/\*/g, wildcard); 
				//mask = ".*" + mask + ".*";
				//Allow only any beginning but fixed ending
				if(mask.indexOf(".*") != 0){
					mask = ".*" + mask;
				}
				return new RegExp(mask + "$", "i");
			};
		};
		return ElementsPathUtils;
	}
);





//////////////////
// WEBPACK FOOTER
// ./utils/ElementsPathUtils.js
// module id = 7
// module chunks = 0